var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { class: { mobile: _vm.isMobile(_vm.$mq) } },
    [
      _vm.showModal
        ? _c("CourseSubpackInterestModal", {
            on: {
              "subpack-button-clicked": function($event) {
                _vm.showModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile(_vm.$mq)
        ? _c("div", { staticClass: "info" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "price" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "track",
                      rawName: "v-track:click",
                      value: {
                        axId: "clicked_math_subpack"
                      },
                      expression:
                        "{\n          axId: 'clicked_math_subpack',\n        }",
                      arg: "click"
                    }
                  ],
                  staticClass: "btn btn-green",
                  on: {
                    click: function($event) {
                      _vm.showModal = true
                    }
                  }
                },
                [_vm._v("\n        Subscribe now\n      ")]
              )
            ])
          ])
        : _c(
            "div",
            { staticClass: "mobile-subpack" },
            [
              _c("PaywallPlan", {
                attrs: { plan: _vm.mathSubPack, upgrade: false, subpack: true },
                on: {
                  "subpack-button-clicked": function($event) {
                    _vm.showModal = true
                  }
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("MathSubPackSvg", { staticClass: "subpack-asset" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "heading" }, [
      _c("h2", [
        _vm._v("Math courses plan "),
        _c("span", { staticClass: "small-text" }, [_vm._v("(Annual)")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", { staticClass: "small-text" }, [
        _vm._v(
          "\n        Access to 40+ math courses, covering: Mathematical Thinking, Logic, Algebra, Geometry,\n        Statistics, Calculus, and more.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [_vm._v("$4.99 "), _c("span", [_vm._v("/month*")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }